import React, { useEffect, useRef } from "react";
import Swal from "sweetalert2";
import DMTaskTimer from "pages/WorkModule/Digital Marketing/Task Switch/DMTaskTimer";
import ProjectTimer from "pages/WorkModule/Projects/Project Timer/ProjectTimer";
import { useTimer } from "pages/WorkModule/Projects/Project Timer/TimerContext";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import {
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData";
import SupportTimer from "pages/WorkModule/Support/Timer/SupportTimer";

const TimerChange = () => {
  const { handleStartStop, formattedTime, currentTaskId, isRunning } =
    useTimer();

  const isCodeTime = localStorage.getItem("code_time");
  const isTicketTime = localStorage.getItem("isTicketTime");

  const onStopTimer = async () => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure ",
      text: "Do you want to stop",
      showCancelButton: true,
      confirmButtonText: "Yes, Stop!",
      cancelButtonText: "No, Keep it running",
    }).then(async (ifYes) => {
      if (!ifYes.isConfirmed) return;

      const token = secureLocalStorage.getItem("auth_token");
      const date = new Date();

      // Check if DM timer is running
      if (localStorage.getItem("DMtimer")) {
        // Stop DM Timer
        const res = await FetchNodePostData(() => {}, "dmTimer/end", token, {
          id: localStorage.getItem("timerId"),
        });

        if (res?.data?.status) {
          // Clear DM timer info from localStorage
          localStorage.removeItem("task_id");
          localStorage.removeItem("timerId");
          localStorage.removeItem("start_time");
          localStorage.removeItem("isTicketTime");
          localStorage.removeItem("code_time");
          localStorage.removeItem("DMtimer");

          // Stop frontend timer
          handleStartStop(currentTaskId, formattedTime);
        }
      } else {
        // Existing logic for Project, Support, CodeReview timers
        const formEntries = {
          staff_id: localStorage.getItem("auth_id"),
          task_id: currentTaskId,
          end_time: moment(date).format("YYYY-MM-DD HH:mm:ss"),
          type: 2,
          timer_id: localStorage.getItem("timerId"),
        };

        const isOtherTimers = isCodeTime === "true" || isTicketTime == "true";

        const res = isOtherTimers
          ? await FetchNodePostData(
              () => {},
              "codeReviewTimer/stopTimer",
              token,
              { id: localStorage.getItem("timerId") }
            )
          : await FetchPostData(
              () => {},
              "startStopTaskTimer",
              token,
              formEntries
            );

        if (isOtherTimers ? res?.data?.status : res?.data?.success) {
          localStorage.removeItem("isTicketTime");
          localStorage.removeItem("code_time");
          handleStartStop(currentTaskId, formattedTime);
        }
      }
    });
  };

  const token = secureLocalStorage.getItem("auth_token");
  const apiCalledRef = useRef(false);

  useEffect(() => {
    const getTimerDetail = async () => {
      const res = await fetchNodeData(
        () => {},
        `getTimerStatus/${localStorage.getItem("auth_id")}`,
        token
      );
      if (res?.status) {
        if (res?.projectTimer?.end_time != null) {
          handleStartStop(res?.projectTimer?.task_id, formattedTime);
        } else if (res?.supportTimer?.end_time != null) {
          handleStartStop(res?.supportTimer?.task_id, formattedTime);
        } else if (res?.codeReviewTimer?.end_time != null) {
          handleStartStop(res?.codeReviewTimer?.task_id, formattedTime);
        }
      }
    };

    if (isRunning && formattedTime !== "00:00:00" && !apiCalledRef.current) {
      apiCalledRef.current = true;
      // getTimerDetail();
    }

    if (!isRunning) {
      apiCalledRef.current = false;
    }
  }, [isRunning, formattedTime]);

  return (
    <div>
      <div className="d-flex gap-2 text-white align-items-center">
        {secureLocalStorage.getItem("auth_role") == 15 ||
        localStorage.getItem("auth_id") == 1 ? (
          <DMTaskTimer />
        ) : null}
        {secureLocalStorage?.getItem("auth_role") == 1 ||
        secureLocalStorage?.getItem("auth_role") == 5 ||
        secureLocalStorage?.getItem("auth_role") == 18 ||
        secureLocalStorage?.getItem("auth_role") == 19 ||
        secureLocalStorage?.getItem("auth_role") == 24  ||
        secureLocalStorage?.getItem("auth_role") == 28 ||
        secureLocalStorage?.getItem("auth_role") == 29 ? (
          <>
            <ProjectTimer />
            <span className="mb-0"># {currentTaskId}</span>
            <span className="mb-0">{formattedTime}</span>
            {isRunning ? (
              <a onClick={onStopTimer} className="text-danger">
                <i className="far fa-stop-circle "></i>
              </a>
            ) : null}
          </>
        ) : null}
        {secureLocalStorage.getItem("auth_role") == 20 ? (
          <SupportTimer />
        ) : null}
      </div>
    </div>
  );
};

export default TimerChange;
